import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { AuthProvider } from "./providers/Auth";

import config from "./config/config";
import { IntercomProvider } from "react-use-intercom";
import { RouterProvider } from "./providers/Routes";
import { ErrorBoundary } from "providers/ErrorBoundary";
import { ProgressProvider } from "providers/ProgressContext";
import { Slide, ToastContainer } from "react-toastify";
import { PostHogProvider } from "posthog-js/react";
import "react-toastify/dist/ReactToastify.css";
import { ChatProvider } from "providers/Chat";
import { MediaQueryProvider } from "shared/providers";
import { DatadogProvider } from "providers/DatadogProvider";
import { NotificationProvider } from "./providers/NotificationProvider";
// eslint-disable-next-line sonarjs/deprecation -- This is a deprecated import, but it is still used in the codebase.
import { createHttpLink } from "@apollo/client/link/http";
// eslint-disable-next-line sonarjs/deprecation -- This is a deprecated import, but it is still used in the codebase.
import { setContext } from "@apollo/client/link/context";

import "react-big-calendar/lib/css/react-big-calendar.css";

import "react-data-grid/lib/styles.css";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";

// eslint-disable-next-line sonarjs/deprecation -- This is a deprecated import, but it is still used in the codebase.
const httpLink = createHttpLink({
  uri: config.apiHost,
  credentials: "include"
});
// eslint-disable-next-line sonarjs/deprecation -- This is a deprecated import, but it is still used in the codebase.
const authLink = setContext((_, { headers }) => {
  const token =
    typeof window !== "undefined" ? window.localStorage.getItem("token") : null;

  return {
    headers: {
      ...headers,
      ...(token && token !== "null" ? { Authorization: `Bearer ${token}` } : {})
    }
  };
});
const client = new ApolloClient({
  link: authLink.concat(httpLink),
  ssrMode: typeof window === "undefined",
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          availability: {
            keyArgs: ["type", "date", "id", "dayOfWeek"]
          },

          propertyManagers: {
            keyArgs: [],
            merge(existing: any, incoming, args) {
              const offset = args.args?.offset ?? 0;

              const merged =
                existing && existing.items?.length
                  ? { items: [...existing.items], total: existing.total ?? 0 }
                  : { total: 0, items: [] };

              merged.total = incoming.total ?? 0;
              for (let i = 0; i < incoming.items.length; ++i)
                merged.items[offset + i] = incoming.items[i];

              return merged;
            }
          }
        }
      }
    }
  })
});

const INTERCOM_APP_ID = config.intercomId!;
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false
    }
  }
});

const options = {
  api_host: config.posthog.host
};

function App() {
  return (
    <>
      <DatadogProvider />

      <ErrorBoundary>
        <IntercomProvider appId={INTERCOM_APP_ID}>
          <PostHogProvider apiKey={config.posthog.key} options={options}>
            <ApolloProvider client={client}>
              <QueryClientProvider client={queryClient}>
                <AuthProvider>
                  <ProgressProvider>
                    <ChatProvider>
                      <MediaQueryProvider>
                        <NotificationProvider>
                          <RouterProvider />
                        </NotificationProvider>
                      </MediaQueryProvider>
                    </ChatProvider>
                  </ProgressProvider>
                </AuthProvider>
              </QueryClientProvider>
            </ApolloProvider>
          </PostHogProvider>
          <ToastContainer
            limit={3}
            style={{
              padding: "16px",
              borderRadius: "8px",
              fontSize: "14px"
            }}
            transition={Slide}
            className="toast-container no-print"
            hideProgressBar
            closeButton={false}
            closeOnClick
            position="bottom-center"
            autoClose={2500}
            theme="colored"
          />
        </IntercomProvider>
      </ErrorBoundary>
    </>
  );
}

export default App;
